import {Component, OnInit} from '@angular/core';
import {RoutingService} from '../../services/routing.service';
import {combineLatest, map, startWith, switchMap} from 'rxjs';
import {LpAccreditationService} from 'src/app/services/lp/lp-accreditation.service';
import {AccreditationDto} from 'src/app/shared/models/AccreditationDto.model';
import {LpNotificationsService} from 'src/app/services/lp/lp-notifications.service';
import HoldingDiscriminator from 'src/app/shared/enums/HoldingDiscriminator.enum';
import {LpTopNotificationService} from './lp-top-notification.service';

@Component({
  selector: 'terra-lp-top-notification',
  templateUrl: './lp-top-notification.component.html',
  providers: [LpNotificationsService],
  styleUrls: ['./lp-top-notification.component.scss']
})
export class LpTopNotificationComponent implements OnInit {

  readonly pendingPaymentRequestMsg = 'Payment request is waiting';
  readonly accreditationMsg = 'Payment request is waiting';
  readonly pendingPaymentRequest = 'Payment request is waiting';


  allAccreditation$ = this.lpAccreditationService.allRequireAccreditation$.pipe(startWith([]));

  notifications$ = this.notificationsService.shouldRefreshNotifications$.pipe(switchMap(_ => this.notificationsDataService.getNotifications()));

  actionRequire$ = combineLatest([this.notifications$, this.allAccreditation$]).pipe(
    map(([{pendingPaymentRequestsNotification, needAttentionBanksNotification}, allAccreditation]) => {
      const ar = [];

      allAccreditation.forEach(item => {
        ar.push({msg: `Accreditation request is waiting for ${item.investingEntityName}`, click: () => this.accreditation(item)});
      })

      pendingPaymentRequestsNotification.forEach(item => {
        ar.push({msg: `Payment request from ${item.companyName} is waiting`, link: this.getPaymentRequestCapitalCallTabUrl(item)});
      });

      if (needAttentionBanksNotification && needAttentionBanksNotification.numOfBanksNeedAttention) {
        ar.push({msg: `Bank account details are missing for ${needAttentionBanksNotification.numOfBanksNeedAttention} deals`, link: this.routingService.lpBankAccounts});
      }

      return ar;
    })
  );

  constructor(private notificationsService: LpTopNotificationService,
    private routingService: RoutingService,
    private notificationsDataService: LpNotificationsService,
    private lpAccreditationService: LpAccreditationService) { }

  ngOnInit() {
  }

  getPaymentRequestCapitalCallTabUrl(paymentRequest: {id: number, companyName: string, holdingDiscriminator: string}): string {
    const discriminator = HoldingDiscriminator.parse(paymentRequest.holdingDiscriminator)
    return this.routingService.lpHoldingPageWithTab(paymentRequest.id, discriminator, 'capital-call');
  }

  accreditation(acc: AccreditationDto) {
    this.lpAccreditationService.openAccreditationFlow(acc);
  }
}
